import { InfoLaboratoryViewModel } from 'app/shared/prothesis-api-view-models/info-laboratory.view-model';
import { ReadAllowedLaboratoryViewModel } from 'app/shared/prothesis-api-view-models/read-allowed-laboratory.view-model';
import { LaboratoryTenantModel } from '../models/laboratory-tenant-model';

export class LaboratoryTenantModelHelper {
  public static fromInfoLaboratoryViewModel(viewModels: InfoLaboratoryViewModel[]): Array<LaboratoryTenantModel> {
    const models = new Array<LaboratoryTenantModel>();
    viewModels.forEach((viewModel) => {
      const model = this._createModelFromInfoLaboratoryViewModel(viewModel);
      models.push(model);
    });

    return models;
  }

  public static fromInfoLaboratoryViewModelSingle(viewModel: InfoLaboratoryViewModel): LaboratoryTenantModel {
    return this._createModelFromInfoLaboratoryViewModel(viewModel);
  }

  public static fromReadAllowedLaboratoryViewModel(viewModels: ReadAllowedLaboratoryViewModel[]): Array<LaboratoryTenantModel> {
    const models = new Array<LaboratoryTenantModel>();
    viewModels.forEach((viewModel) => {
      const model = this._createModelFromReadAllowedLaboratoryViewModel(viewModel);
      models.push(model);
    });

    return models;
  }

  public static fromReadAllowedLaboratoryViewModelSingle(viewModel: ReadAllowedLaboratoryViewModel): LaboratoryTenantModel {
    return this._createModelFromReadAllowedLaboratoryViewModel(viewModel);
  }

  private static _createModelFromInfoLaboratoryViewModel(infoLaboratoryViewModel: InfoLaboratoryViewModel): LaboratoryTenantModel {
    const laboratoryTenant = new LaboratoryTenantModel();
    laboratoryTenant.demoModeFlag = infoLaboratoryViewModel.demoModeFlag;
    laboratoryTenant.name = infoLaboratoryViewModel.name;
    laboratoryTenant.tzDatabaseName = infoLaboratoryViewModel.tzDatabaseName;
    laboratoryTenant.uuid = infoLaboratoryViewModel.uuid;
    return laboratoryTenant;
  }

  private static _createModelFromReadAllowedLaboratoryViewModel(
    readAllowedLaboratoryViewModel: ReadAllowedLaboratoryViewModel,
  ): LaboratoryTenantModel {
    const laboratoryTenant = new LaboratoryTenantModel();
    laboratoryTenant.demoModeFlag = readAllowedLaboratoryViewModel.demoModeFlag;
    laboratoryTenant.name = readAllowedLaboratoryViewModel.name;
    laboratoryTenant.tzDatabaseName = readAllowedLaboratoryViewModel.tzDatabaseName;
    laboratoryTenant.uuid = readAllowedLaboratoryViewModel.uuid;
    return laboratoryTenant;
  }
}
